import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import {
  PartnershipValidationStepFailure,
  PartnershipValidationStepRequest,
  PartnershipValidationStepSuccess,
} from './actions';
import { PartnershipValidationStepService } from './service';

@Injectable()
export class PartnershipValidationStepEffects {
  private readonly actions$ = inject(Actions);
  private readonly partnershipValidationStepService = inject(PartnershipValidationStepService);

  partnershipValidationStep$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PartnershipValidationStepRequest),
      switchMap(({ body, parameters }) =>
        this.partnershipValidationStepService.partnershipValidationStep(body, parameters).pipe(
          map(data => PartnershipValidationStepSuccess({ data })),
          catchError(error => of(PartnershipValidationStepFailure({ error })))
        )
      )
    )
  );

}
